
import { AppsAddIn24Filled, AppsAddIn24Regular ,bundleIcon} from "@fluentui/react-icons";

export const ModuleIcon = bundleIcon(AppsAddIn24Filled, AppsAddIn24Regular);